import { useState } from "react";
import { PrimeiroMilhaoInputCard } from "./components/PrimeiroMilhaoInputCard";
import { PrimeiroMilhaoResponse } from "./components/PrimeiroMilhaoResponse";

export default function PrimeiroMilhao() {
  const [results, setResults] = useState<PrimeiroMilhaoResultsType | null>(null);

  return (
    <>
      <PrimeiroMilhaoInputCard setResults={setResults} />
      {results && <PrimeiroMilhaoResponse results={results} />}
    </>
  );
}